import { FC, useState } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import CarsListingModel from "models/CarsListingModel";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useData } from "data/data-provider";
export interface FleetCardProps {
  className?: string;
  data?: any;
  size?: "default" | "small";
  simpleImg?: boolean;
  onClick?: any;
}

const FleetCard: FC<FleetCardProps> = ({
  size = "default",
  className = "",
  data,
  simpleImg = false,
  onClick,
}) => {
  const {
    id,
    fleet_photos,
    name,
    color,
    seats,
    avg_car_price_per_day,
    description,
    thumbnail_photo_url,
  } = data!;
  const location = useLocation();
  const navigate = useNavigate();
  const { setSelectedCar } = useData();
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState<{
    top: number;
    left: number;
  }>({ top: 0, left: 0 });
  const [loadingId, setLoadingId] = useState<string | null>(null);

  const handleMouseEnter = (e: React.MouseEvent) => {
    setIsHovered(true);
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
    });
  };

  const handleMouseLeave = () => setIsHovered(false);




  const renderSliderGallery = () => {
    return (
    <>
        {/* {simpleImg ? ( */}
        <img
          src={
            fleet_photos && fleet_photos.length > 0
              ? `https://fleet-management-images-upload-be.s3.amazonaws.com/${encodeURIComponent(
                thumbnail_photo_url
              )}`
              : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
          }
          alt="name"
          className="h-full object-cover "
        />
      </>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-2" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <h2
              className={` font-medium capitalize ${size === "default" ? "text-lg" : "text-base"
                }`}
            >
              <span className="line-clamp-1 tr">{name}</span>
            </h2>
          </div>

        


          <span className=" text-sm">
            <span className="font-semibold">{seats}</span> seats{" "}
            <span className="font-semibold">{color}</span> color
          </span>
        </div>
        <div className="relative group">
            <span
              className=" cursor-pointer relative line-clamp-3  text-ellipsis"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {description}
            </span>
          </div>
          {isHovered &&
  createPortal(
    <div
      className="absolute bg-[#fbfaeb] text-black text-xs rounded-md px-2 py-1 shadow-lg z-50 pointer-events-none"
      style={{
        top: tooltipPosition.top + 24,
        left: tooltipPosition.left,
        maxWidth: "250px",
        whiteSpace: "normal",
        wordWrap: "break-word",
      }}
    >
      {description}
    </div>,
    document.body
  )}

        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div>
        <div className="flex justify-between items-center">
          {/* <span className="text-base font-semibold">
            {avg_car_price_per_day ? "$" + avg_car_price_per_day : "$" + 0}

            {` `}
            {size === "default" && (
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                /day
              </span>
            )}
          </span> */}
        </div>
        <ButtonPrimary
          onClick={() => {
            navigate("/car-listing-detail");
            setSelectedCar(data);
          }}
        >
          Book Now
        </ButtonPrimary>
      </div>
    );
  };

  return (
    <div
      className={` flex flex-row  bg-white dark:bg-[#121212] border border-[#00000080] dark:border-neutral-800 rounded-2xl  will-change-transform hover:shadow-xl transition-shadow h-64 ${className}${location.pathname === "/available-car" ? "cursor-pointer" : ""
        }`}
      data-nc-id="StayCard"
      onClick={onClick}
    >
      <div className="w-full">
        {renderSliderGallery()}

      </div>    <div className="w-full">

        {renderContent()}
      </div>

    </div>
  );
};

export default FleetCard;
